import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

import ErrorBox from '../common/ErrorBox';

const propTypes = {
    show: PropTypes.bool,
    hasError: PropTypes.bool,
    modalTitle: PropTypes.string,
    confirmButtonText: PropTypes.string,
    closeHandler: PropTypes.func.isRequired,
    confirmPhrase: PropTypes.string.isRequired,
    children: PropTypes.node,
    message: PropTypes.string,
    confirmHandler: PropTypes.func.isRequired,
    cancelHandler: PropTypes.func,
    cancelButtonText: PropTypes.string,
    confirmData: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number]),
    confirmButtonBsStyle: PropTypes.oneOf(['primary', 'danger']),
    allowCaseInsensitive: PropTypes.bool,
};

const defaultProps = {
    show: true,
    hasError: false,
    modalTitle: 'Confirm Decision',
    confirmButtonText: 'confirm',
    children: null,
    message: '',
    cancelHandler: () => { return; },
    cancelButtonText: '',
    confirmData: null,
    confirmButtonBsStyle: 'primary',
    allowCaseInsensitive: false,
};

class ConfirmPhraseModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phraseInput: '',
        };
        this.inputElem = React.createRef();
        this.onPhraseChange = this.onPhraseChange.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
    }

    componentDidMount() {
        this.focusOnInput()
    }

    onPhraseChange(e) {
        this.setState({ phraseInput: e.target.value });
    }

    focusOnInput() {
        const inputElem = this.inputElem.current;
        if (!inputElem) {
            return;
        }

        inputElem.focus();
    }

    render() {
        let phraseMatches = this.props.confirmPhrase === this.state.phraseInput;
        if (this.props.allowCaseInsensitive && !phraseMatches) {
            phraseMatches = this.props.confirmPhrase.toLower() === this.state.phraseInput.toLower();
        }

        return (
            <Modal
                show={this.props.show}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>{this.props.modalTitle}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.props.hasError ? <ErrorBox error={{ message: this.props.message }} /> : null}
                    {this.props.children}
                    <label htmlFor="cp-input" className="block">Please type <em className="font-style-italic">{this.props.confirmPhrase}</em> to confirm:</label>
                    <input id="cp-input" ref={this.inputElem} onChange={this.onPhraseChange} value={this.props.phraseInput} />
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        disabled={!phraseMatches}
                        variant={this.props.confirmButtonBsStyle}
                        onClick={this.props.confirmHandler.bind(null, this.props.confirmData)}
                    >
                        {this.props.confirmButtonText}
                    </Button>
                    {this.props.cancelButtonText &&
                        <Button onClick={this.props.cancelHandler}>
                            {this.props.cancelButtonText}
                        </Button>
                    }
                </Modal.Footer>
            </Modal>
        );
    }
}

ConfirmPhraseModal.propTypes = propTypes;
ConfirmPhraseModal.defaultProps = defaultProps;

export default ConfirmPhraseModal;
